import React from 'react'

import { SvgProps } from './types'

function MultiWindowSvg({
  width,
  height,
  className,
  stroke,
  fill,
  strokeColor,
  size,
  styles,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          height: 'auto',
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width={width || '48'}
      height={height || '48'}
      viewBox="0 0 18 18"
      fill={fill || 'none'}
    >
      <path
        d="M11.25 5.25V4.5C11.25 3.67157 10.5784 3 9.75 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V9C2.25 9.82843 2.92157 10.5 3.75 10.5H4.5M8.25 15H14.25C15.0784 15 15.75 14.3284 15.75 13.5V9C15.75 8.17157 15.0784 7.5 14.25 7.5H8.25C7.42157 7.5 6.75 8.17157 6.75 9V13.5C6.75 14.3284 7.42157 15 8.25 15Z"
        stroke={strokeColor || 'currentColor'}
        strokeWidth={stroke || 1.5}
      />
    </svg>
  )
}

export default MultiWindowSvg
